export default __webpack_public_path__ + "static/media/459.27224515.png";